import React, { useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form';
import { FiPlusCircle, FiTrash2 } from 'react-icons/fi';
import Swal from "sweetalert2";
import { Table } from '../../Table';
import { InputValidators } from '../../../utils/validators/InputValidators';

export const CardCobroOrdenes = ({ storage, listServices, listParts, avancedPayments, listDiscount, listPaymentMethods, costStorage, onUpdate }) => {

    const diasGracia = costStorage.DIAS_GRACIA;
    const tAlmacenamiento = costStorage.COSTO;

    const baseServicios = listServices?.reduce((acc, item) => (
        item.AUTORIZO == 1 && item.ESTADO == 1 ? acc + (Number(item.COSTO) / 1.16) : acc
    ), 0) || 0;

    const baseRefacciones = listParts?.reduce((acc, item) => (
        item.ESTADO == 5 ? acc + (Number(item.COSTO_CLIENTE) / 1.16) : acc
    ), 0) || 0;

    // const baseAnticipos = avancedPayments?.reduce((acc, item) => acc + Number(item.MONTO), 0) || 0;

    const baseAnticipos = avancedPayments?.reduce((acc, item) => {
        if (item.ACTIVE === '1') {
            acc += Number(item.MONTO);
        }
        return acc;
    }, 0) || 0;


    const dCobroAlmacenamiento = Math.max(0, Number(storage) - diasGracia);
    // const baseAlmacenamiento = dCobroAlmacenamiento * tAlmacenamiento;
    const baseAlmacenamiento = (dCobroAlmacenamiento * tAlmacenamiento) / 1.16;

    // Estados de descuentos (%)
    const [descServicios, setDescServicios] = useState(0);
    const [descRefacciones, setDescRefacciones] = useState(0);
    const [descAlmacenamiento, setDescAlmacenamiento] = useState(0);

    // Calcular acumulados con descuentos
    const acumuladoServicios = useMemo(
        () => baseServicios * (1 - descServicios / 100),
        [baseServicios, descServicios]
    );

    const acumuladoRefacciones = useMemo(
        () => baseRefacciones * (1 - descRefacciones / 100),
        [baseRefacciones, descRefacciones]
    );

    const acumuladoAlmacenamiento = useMemo(
        () => baseAlmacenamiento * (1 - descAlmacenamiento / 100),
        [baseAlmacenamiento, descAlmacenamiento]
    );


    //  Descuentos para retorno:
    const descuentoServiciosMonto = baseServicios - acumuladoServicios;
    const descuentoRefaccionesMonto = baseRefacciones - acumuladoRefacciones;
    const descuentoAlmacenamientoMonto = baseAlmacenamiento - acumuladoAlmacenamiento;

    const descuentos = useMemo(() => {
        const arr = [];

        if (descAlmacenamiento > 0 && descuentoAlmacenamientoMonto > 0) {
            arr.push({
                origen: 1,
                aplicado: 1,
                tipo: 'ALMACENAMIENTO',
                porcentaje: descAlmacenamiento,
                base: Number(baseAlmacenamiento.toFixed(2)),
                monto: Number(descuentoAlmacenamientoMonto.toFixed(2))
            });
        }

        if (descServicios > 0 && descuentoServiciosMonto > 0) {
            arr.push({
                origen: 1,
                aplicado: 2,
                tipo: 'SERVICIOS',
                porcentaje: descServicios,
                base: Number(baseServicios.toFixed(2)),
                monto: Number(descuentoServiciosMonto.toFixed(2))
            });
        }

        if (descRefacciones > 0 && descuentoRefaccionesMonto > 0) {
            arr.push({
                origen: 1,
                aplicado: 3,
                tipo: 'REFACCIONES',
                porcentaje: descRefacciones,
                base: Number(baseRefacciones.toFixed(2)),
                monto: Number(descuentoRefaccionesMonto.toFixed(2))
            });
        }

        return arr;
    }, [
        descAlmacenamiento,
        descServicios,
        descRefacciones,
        baseAlmacenamiento,
        baseServicios,
        baseRefacciones,
        acumuladoAlmacenamiento,
        acumuladoServicios,
        acumuladoRefacciones
    ]);





    const subtotalGravado = acumuladoServicios + acumuladoRefacciones + acumuladoAlmacenamiento;
    const iva = subtotalGravado * 0.16;
    const total = subtotalGravado + iva - baseAnticipos;

    // Procesamiento de Pagos
    const [pagos, setPagos] = useState([]);
    const { register, handleSubmit, reset, getValues, setValue, watch, formState: { errors } } = useForm({ model: 'all', defaultValues: { metodo: "", comentarios: "", monto: "" } });

    const onSubmit = (data) => {
        const nuevoPago = {
            metodo: data.metodo,
            comentarios: data.comentarios,
            monto: Number(data.monto)
        };

        setPagos([...pagos, nuevoPago]);
        reset();
    };

    const handleDeleteRow = (row) => {
        Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: `Está por eliminar una forma de pago, ¿desea continuar con esta acción?`,
            showCancelButton: true, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar',
            customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-secondary ms-2' }, buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                setPagos(prev => prev.filter(p =>
                    !(p.metodo === row.metodo && p.comentarios === row.comentarios && p.monto === row.monto)
                ));
            }
        });
    }

    const totalPagado = pagos.reduce((acc, p) => acc + p.monto, 0);
    const cambio = totalPagado > total ? totalPagado - total : 0;
    const faltante = total > totalPagado ? total - totalPagado : 0;

    const columns = [
        {
            header: 'ACCIONES',
            dataIndex: 'acciones',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => (
                <button type="button" className="btn btn-outline-danger  border-0" onClick={() => handleDeleteRow(row)}>
                    <FiTrash2 size={24} />
                </button>
            )
        },
        {
            header: "Forma de pago",
            dataIndex: "metodo",
            renderer: (value) => {
                // Busca el nombre de la forma de pago en la lista
                const pago = listPaymentMethods.find(p => p.ID === value || p.NOMBRE === value);
                return pago ? pago.NOMBRE : value; // si no lo encuentra, mostrar el valor original
            }
        },
        {
            header: "Comentarios",
            dataIndex: "comentarios"
        },
        {
            header: "Monto",
            dataIndex: "monto",
            classRow: "text-end",
            classHeader: 'text-end',
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        }
    ];

    const totalRounded = Number(total.toFixed(2));
    const totalPagadoRounded = Number(totalPagado.toFixed(2));
    const cambioRounded = Number(cambio.toFixed(2));
    const faltanteRounded = Number(faltante.toFixed(2));

    // Retorno de data.
    useEffect(() => {
        onUpdate?.({
            pagos,
            descuentos,
            total: totalRounded,
            totalPagado: totalPagadoRounded,
            cambio: cambioRounded,
            faltante: faltanteRounded,
            iva: Number(iva.toFixed(2)),
            subtotalGravado: Number(subtotalGravado.toFixed(2))
        });
    }, [pagos, descuentos, totalRounded, totalPagadoRounded, cambioRounded, faltanteRounded, iva, subtotalGravado]);


    return (
        <div className="mt-2">
            <div className="card-header border-bottom border-top">
                <h5 className="card-title mb-0 fw-bold text-black">Resumen de la cuenta</h5>
            </div>
            <div className="card-body">
                <div className='table-responsive'>
                    <table className="table table-stripped table-sm">
                        <thead>
                            <tr>
                                <th scope="col">CONCEPTO</th>
                                <th scope="col">COSTO ($)</th>
                                <th scope="col">CANT. (#)</th>
                                <th scope="col">DESCUENTO (%)</th>
                                <th scope="col" className="text-center">ACUMULADO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>ALMACENAMIENTO</td>
                                <td style={{ width: 150 }}> <input type="number" className="form-control  text-end" value={tAlmacenamiento} disabled /> </td>
                                <td style={{ width: 90 }}> <input type="number" className="form-control  text-end" value={dCobroAlmacenamiento} disabled /> </td>
                                <td style={{ width: 300 }}>
                                    <select className="form-select" id="descAlmacenamiento" onChange={e => setDescAlmacenamiento(Number(e.target.value))} value={descAlmacenamiento} >
                                        {listDiscount.map((item) => (<option key={item.ID} value={Number(item.VALOR)}> {item.NOMBRE} </option>))}
                                    </select>
                                </td>
                                <td style={{ width: 150 }}> <input type="number" className="form-control text-end" id="valueStorage" value={(acumuladoAlmacenamiento).toFixed(2)} disabled /> </td>
                            </tr>
                            <tr>
                                <td>SERVICIOS REALIZADOS</td>
                                <td style={{ width: 150 }}> <input type="number" className="form-control text-end" value={baseServicios.toFixed(2)} disabled /> </td>
                                <td style={{ width: 90 }}>  </td>
                                <td style={{ width: 300 }}>
                                    <select className="form-select" id="descServicios" onChange={e => setDescServicios(Number(e.target.value))} value={descServicios}>
                                        {listDiscount.map((item) => (<option key={item.ID} value={Number(item.VALOR)}> {item.NOMBRE} </option>))}
                                    </select>
                                </td>
                                <td style={{ width: 150 }}> <input type="number" className="form-control text-end" id="valueServices" value={acumuladoServicios.toFixed(2)} disabled /> </td>
                            </tr>
                            <tr>
                                <td>REFACCIONES</td>
                                <td style={{ width: 150 }}> <input type="number" className="form-control text-end" value={baseRefacciones.toFixed(2)} disabled /> </td>
                                <td style={{ width: 90 }}> </td>
                                <td style={{ width: 300 }}>
                                    <select className="form-select" id="descParts" onChange={e => setDescRefacciones(Number(e.target.value))} value={descRefacciones}>
                                        {listDiscount.map((item) => (<option key={item.ID} value={Number(item.VALOR)}> {item.NOMBRE}</option>))}
                                    </select>
                                </td>
                                <td style={{ width: 150 }}> <input type="number" className="form-control text-end" id="valueParts" value={acumuladoRefacciones.toFixed(2)} disabled /> </td>
                            </tr>
                            <tr>
                                <td>ANTICIPOS</td>
                                <td style={{ width: 150 }}> <input type="number" className="form-control text-end" value={baseAnticipos.toFixed(2)} disabled /> </td>
                                <td style={{ width: 90 }}>  </td>
                                <td style={{ width: 300 }}>
                                </td>
                                <td style={{ width: 150 }}> <input type="number" className="form-control text-end" value={baseAnticipos.toFixed(2)} disabled /> </td>
                            </tr>

                            {/* Totales */}
                            <tr>
                                <td colSpan={4} className="fw-bold text-end border-0">
                                    SUBTOTAL:
                                </td>
                                <td style={{ width: 150 }} className="border-0"> <input type="number" className="form-control text-end" id="tsubtotal" value={subtotalGravado.toFixed(2)} disabled /> </td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="fw-bold text-end border-0">
                                    IVA:
                                </td>
                                <td style={{ width: 150 }} className="border-0"> <input type="number" className="form-control text-end" id="tIVA" value={iva.toFixed(2)} disabled /> </td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="fw-bold text-end border-0 text-success">
                                    TOTAL A COBRAR:
                                </td>
                                <td style={{ width: 150 }} className="border-0"> <input type="number" className="form-control text-end text-success border-success" id="ttotal" value={totalRounded} disabled /> </td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="fw-bold text-end border-0 text-danger">
                                    FALTANTE:
                                </td>
                                <td style={{ width: 150 }} className="border-0"> <input type="number" className="form-control fw-bold text-end text-danger border-danger" value={faltanteRounded} disabled /> </td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="fw-bold text-end border-0 fw-bold text-primary">
                                    CAMBIO:
                                </td>
                                <td style={{ width: 150 }} className="border-0"> <input type="number" className="form-control border-primary text-end fw-bold text-primary" value={cambioRounded} disabled /> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <hr className="my-0" />

                <div className="mt-3">
                    <form className="row g-2 align-items-end" onSubmit={handleSubmit(onSubmit)}>
                        <div className="col-12 col-md-3">
                            <label className="form-label">Forma de pago:</label>
                            <select className={`form-select ${errors.metodo ? 'is-invalid' : ''}`} {...register("metodo", { required: true })}  >
                                <option value="">Seleccione una opción</option>
                                {
                                    // listPaymentMethods.map((item) => (<option key={item.ID} value={item.ID}> {item.CODE}- {item.nombre}</option>))
                                    listPaymentMethods.map((item) => (<option key={item.ID} value={item.ID}>{item.NOMBRE}</option>))
                                }
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label">Comentarios:</label>
                            <input type="text" className="form-control" {...register("comentarios")} />
                        </div>

                        <div className="col-12 col-md-2">
                            <label className="form-label">Monto:</label>
                            <input type="number" step="any" onKeyDown={InputValidators.validateDecimalKeyDown} className={`form-control ${errors.monto ? 'is-invalid' : ''}`}
                                {...register("monto", { required: true, min: 1, onBlur: (e) => InputValidators.formatDecimalOnBlur_ReactHook(e, "monto", setValue) })}
                            />
                        </div>

                        <div className="col-12 col-md-1 d-flex justify-content-md-center">
                            <button className="btn btn-outline-dark border-0 w-100" type="submit">
                                <FiPlusCircle size={22} />
                            </button>
                        </div>
                    </form>
                </div>

                <div className="row mt-2">
                    <div className='col-12'>
                        <Table
                            columns={columns}
                            data={pagos}
                            function_={(row) => console.log("Doble clic en:", row)}
                            placeholderSearch="Buscar orden"
                            showPagination={false}
                            showControls={false}
                            tableHeight="200px"
                            showTotals={false}
                            msgDisplay={'No se han agregado formas de pago'}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
